import moment from 'moment';
import { useEffect, useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import Skeleton from 'react-loading-skeleton';

function OverviewMentors({ isActiveTab, callsData, performance, isFetching }) {

    const getLastWeekDays = () => {
        var result = [];
        for (var i=1; i<8; i++) {
            var d = new Date();
            d.setDate(d.getDate() - i);
            result.push( moment(d).format("ddd") )
        }
    
        return result;
    };
    //states
    const [totalCalls, setTotalCalls] = useState([]);
    const [completedCalls, setCompletedCalls] = useState([]);
    const [cancelledCalls, setCancelledCalls] = useState([]);
    const [rescheduledCalls, setRescheduledCalls] = useState([]);
    const [unattendedCalls, setUnttendedCalls] = useState([]);

  useEffect(() => {
    if(callsData?.callsGraph?.length > 0) {
      const days = getLastWeekDays();
      let total = [];
      let completed = [];
      let cancelled = [];
      let rescheduled = [];
      let unattended = [];
      days.forEach((day, index) => {
        callsData?.callsGraph?.forEach((item) => {
          if(day === moment(item?.date).format("ddd")) {
            total.push(item?.total);
            completed.push(item?.completed);
            cancelled.push(item?.cancelled);
            rescheduled.push(item?.rescheduled);
            unattended.push(item?.noshow);
          }
        });
        if(total?.length <= index) total.push(0)
        if(completed?.length <= index) completed.push(0)
        if(cancelled?.length <= index) cancelled.push(0)
        if(rescheduled?.length <= index) rescheduled.push(0)
        if(unattended?.length <= index) unattended.push(0)
      });
      setTotalCalls(total);
      setCompletedCalls(completed);
      setCancelledCalls(cancelled);
      setRescheduledCalls(rescheduled);
      setUnttendedCalls(unattended);
    }
  },[callsData])

  const options2 = {
    chart: {
      type: 'bar',
      height: 250,
      stacked: false // Set stacked to false to allow grouping
    },
    fill: {
      colors: ["#0E77D3"]
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '25%', // Adjust the width of the bars
        grouped: true, // Set grouped to true to group the bars
        borderRadius: "4",
      }
    },
    series: [
      {
        name: '',
        data: totalCalls
      }
    ],
    xaxis: {
      categories: getLastWeekDays()
    },
    dataLabels: {
      enabled: false
    },
    tooltip: {
      marker: false,
      x: {
        show: false
      },
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex }) {
          if (seriesIndex === 0) {
            const cancelled = cancelledCalls[dataPointIndex];
            const completed = completedCalls[dataPointIndex];
            const unattended = unattendedCalls[dataPointIndex];
            const rescheduled = rescheduledCalls[dataPointIndex];
  
            return `
              <div class="flexDiv">
                  <div class="custom-tooltip-item tooltipHeading">Total Calls: <span class="dashboardValue">${value}</span></div>
                
                  <div class="flexColumn">
                    <div class="dataDiv">
                      <div class="custom-tooltip-item ">Cancelled: ${cancelled}</div>
                      <div class="custom-tooltip-item ">Completed: ${completed}</div>
                    </div>
                    <div class="dataDiv">
                      <div class="custom-tooltip-item ">No Show: ${unattended}</div>
                      <div class="custom-tooltip-item ">Rescheduled: ${rescheduled}</div>
                    </div>
                  </div>
  
              </div>
            `;
          }
        }
      },
      enabled: true,
      style: {
        fontSize: '12px',
        fontFamily: undefined
      }
    }
  };

    var options3 = {
        chart: {
            id: "basic-bar"
        },
        xaxis: {
            categories: ["Total calls"],
            labels: {
                show: false,
            }
        },
        yaxis: {
            labels: {
                show: false,
            }
        },
        dataLabels: {
            enabled: true,
            offsetY: -20,
            style: {
                colors: ['#000']
              },
              formatter: function (val) {
                if(val) return val + '%';
              },
        },
        fill: {
            colors: ["#7757F4", "#7BC896", "#0E77D3", "#EF5350"]
        },
        tooltip: {
            enabled: false,
            style: {
                color: ["#fff"]
            },
            marker: false
        },
        legend: {
            show: false
        },
        plotOptions: {
            bar: {
                borderRadius: 6,
                borderRadiusApplication: 'end',
                columnWidth: '200%',
                distributed: true,
                dataLabels: {
                    position: "top"
                }
            }
        },
        series: [
            {
                name: "Completed",
                data: [null, (performance?.length > 0 ? ((performance[0]?.completed / performance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Rescheduled",
                data: [null, null, (performance?.length > 0 ? ((performance[0]?.rescheduled / performance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "Cancelled",
                data: [null, null, null, (performance?.length > 0 ? ((performance[0]?.cancelled / performance[0]?.total) * 100 ).toFixed(0) : 0)]
            },
            {
                name: "No Show",
                data: [null, null, null, null, (performance?.length > 0 ? ((performance[0]?.noshow / performance[0]?.total) * 100 ).toFixed(0) : 0), null]
            },
        ]
    };

    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Overview</h2>
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata">

                <div className="AdGraphwrapMntWrap flex">

                    <div className="AdleftgraphMnt Adbackwrapbox">
                        <div className="AdheadingwarpTab flex-between">
                            <div className="Adheadingtab">
                                <h3 className='heading-2 mb-6'>Past Week Call Activity</h3>
                                <p className='text2'>Count of calls</p>
                            </div>
                            {/* <div className="Multibtntabwrap flex gap-10">
                                <div className="btnweek active">Week</div>
                                <div className="btnweek">Month</div>
                                <div className="btnweek">Year</div>
                            </div> */}
                        </div>
                        <div className="Dsmngrapgtext3 flex mt-30 gap-6">
                            <div className="mnmtcountgraph flex gap-6">
                                <h3>{callsData?.totalCallsWeekly ?? 0}</h3>
                                {/* <span className='mtsgrapg'><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.03457 5.15875C8.93957 5.15875 8.84457 5.12375 8.76957 5.04875L5.99957 2.27875L3.22957 5.04875C3.08457 5.19375 2.84457 5.19375 2.69957 5.04875C2.55457 4.90375 2.55457 4.66375 2.69957 4.51875L5.73457 1.48375C5.87957 1.33875 6.11957 1.33875 6.26457 1.48375L9.29957 4.51875C9.44457 4.66375 9.44457 4.90375 9.29957 5.04875C9.22957 5.12375 9.12957 5.15875 9.03457 5.15875Z" fill="#7BC896" />
                                    <path d="M6 10.6259C5.795 10.6259 5.625 10.4559 5.625 10.2509V1.83594C5.625 1.63094 5.795 1.46094 6 1.46094C6.205 1.46094 6.375 1.63094 6.375 1.83594V10.2509C6.375 10.4559 6.205 10.6259 6 10.6259Z" fill="#7BC896" />
                                </svg>  7% from last month</span> */}
                            </div>

                            <p className='text2'>Total count of calls completed in this duration</p>
                        </div>

                        <div>
                        {isFetching?
                          <div>
                          {[...Array(5)].map((_, index) => (
                            <Skeleton key={index} height={30} style={{ marginBottom: '10px' }} />
                          ))}
                        </div>
                        :
                        <ReactApexChart
                        options={options2}
                        series={options2.series}
                        type="area"
                        height={250}
                        />}
                        </div>
                    </div>

                    <div className="AdrightgraphMnt Adbackwrapbox">
                        <div className="AdheadingwarpTab flex-between">
                            <div className="Adheadingtab">
                                <h3 className='heading-2 mb-6'>Performance <span className='smallText text2'>(Current month)</span></h3>
                                <p className='text2'>{performance?.length > 0 && (performance[0]?.total ?? 0)} Total calls</p>
                            </div>
                            {/* <label htmlFor="date" className='Cudatedesign'>
                                <input type="date" id='date' />
                            </label> */}
                        </div>
                        {isFetching?
                          <div>
                          {[...Array(8)].map((_, index) => (
                            <Skeleton key={index} height={30} style={{ marginBottom: '10px' }} />
                          ))}
                        </div>
                        :
                        <ReactApexChart className={'mt-30'}
                            options={options3}
                            series={options3.series}
                            type="bar"
                            width="100%"
                            height="290px"
                        />}
                        <div className="AdDataGraphwarp">
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Completed</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Cancelled</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> Rescheduled</p>
                            </div>
                            <div className="dataAdstatana w-100">
                                <div className='circleround'></div>
                                <p className='text2'> No show</p>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default OverviewMentors